/**
 * English is the key, so this dictionary is a passthrough and stays empty
 * until a string needs an override. The value of the file is that it becomes
 * Charlie's string catalogue: every key that ever reaches t() is collectable
 * from source, and the error message catalogue lands here pre written in the
 * product's voice so error copy never gets improvised at implementation time.
 */

export const en: Record<string, string> = {
  /**
   * The one override the appearance section needs, and the reason it is an
   * override rather than an inline string: a language picker names each
   * language in that language, because the person looking for Thai is the
   * person who cannot read the word "Thai". The key stays English so the
   * catalogue rule holds, and th.ts carries the identical value, because this
   * is a string that is invariant rather than translated.
   */
  Thai: 'ไทย',
};
